import { defineStore } from 'pinia'
import { PenaltyVo } from '@/api/penalty/penaltyType'

// 罚款
export const usePenaltyStore = defineStore(
  'penalty',
  () => {
    const penaltyDetail = ref<PenaltyVo>()

    const editingOrder = ref<PenaltyVo>()

    return {
      penaltyDetail,
      editingOrder,
    }
  },
)
